import { render, staticRenderFns } from "./CreateTenantsWidgetModal.vue?vue&type=template&id=36eef1c2&scoped=true"
import script from "./CreateTenantsWidgetModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateTenantsWidgetModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateTenantsWidgetModal.vue?vue&type=style&index=0&id=36eef1c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eef1c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36eef1c2')) {
      api.createRecord('36eef1c2', component.options)
    } else {
      api.reload('36eef1c2', component.options)
    }
    module.hot.accept("./CreateTenantsWidgetModal.vue?vue&type=template&id=36eef1c2&scoped=true", function () {
      api.rerender('36eef1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apps/tenants/CreateTenantsWidgetModal.vue"
export default component.exports